import React from 'react'
import UserProfileEditor from "./Editores/UserProfileEditor/UserProfileEditor.jsx";
import DireccionEditor from "./Editores/DireccionEditor/DireccionEditor.jsx";
import MediosInputSVGEditor from "./Editores/MediosEditor/MediosInputSVGEditor.jsx";
import MediosInputImgEditor from "./Editores/MediosEditor/MediosInputImgEditor.jsx";
// import MediosInputTextEditor from "./Editores/MediosEditor/MediosInputTextEditor/MediosInputTextEditor.jsx";
import ClienteEditor from "./Editores/ClienteEditor/ClienteEditor.jsx";
import ClienteViewer from "./Editores/ClienteEditor/ClienteViewer.jsx";
import ProyectoEditor from "./Editores/ProyectoEditor/ProyectoEditor.jsx";
import ProyectoViewer from "./Editores/ProyectoEditor/ProyectoViewer.jsx";
import PresupuestoEditor from "./Editores/PresupuestoEditor/PresupuestoEditor.jsx";
import PresupuestoViewer from "./Editores/PresupuestoEditor/PresupuestoViewer.jsx";
import ItemPresupuestoEditor from "./Editores/PresupuestoEditor/ItemPresupuestoEditor/ItemPresupuestoEditor.jsx";
import ItemPresupuestoViewer from "./Editores/PresupuestoEditor/ItemPresupuestoEditor/ItemPresupuestoViewer.jsx";
import {useEditor} from "../../../../App.jsx";
import VerMiProyecto from "../../pages/MisProyectos/VerMiProyecto.jsx";
import VerMiPresupuesto from "../../pages/MisProyectos/VerMiPresupuesto.jsx";
import ProductoEditor from "./Editores/ProductoEditor/ProductoEditor.jsx";
import {mdiArrowLeft} from "@mdi/js";
import DraggableBackButton from "./DraggableBackButton.jsx";
import TokenLinkEditor from "./Editores/Admin/TokenLinkEditor/TokenLinkEditor.jsx";
// import ItemPresupuestoViewer from "./Editores/PresupuestoEditor/ItemPresupuestoViewer.jsx";
// import ItemPresupuestoEditor from "./Editores/PresupuestoEditor/ItemPresupuestoEditor.jsx";




const Editor = ({children, setEditor, editorType, id, setEditorID, setEditorType}) => {


    const { stateEditor, setStateEditor } = useEditor();
    const closedByPopstate = React.useRef(false);

    // El editor vive en una entrada propia del historial: el botón "atrás" del
    // navegador/ratón lo cierra en vez de abandonar la página, y al cerrarlo
    // desde la UI se consume esa entrada para no dejar el historial sucio.
    React.useEffect(() => {
        window.history.pushState({ ...window.history.state, customiz3dEditor: true }, "");
        const onPopState = () => {
            closedByPopstate.current = true;
            setStateEditor((prev) => ({
                ...prev,
                editor: false,
                editorType: null,
                editorID: null,
            }));
        };
        window.addEventListener("popstate", onPopState);
        return () => {
            window.removeEventListener("popstate", onPopState);
            if (!closedByPopstate.current && window.history.state?.customiz3dEditor) {
                window.history.back();
            }
        };
    }, []);

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }


    return (
        <div className="w-full h-full ">
            <div
                className={classNames(
                    'h-full',

                    'rounded-xl  ',
                    'ring-white/60 ring-offset-2 ring-offset-blue-400 '
                )}

            >
                <div className="w-full h-full">
                    {children}
                    {stateEditor.editorType == 'profileUser' && <UserProfileEditor setEditor={setEditor} setEditorID={setEditorID} />}
                    {(stateEditor.editorType == 'directions' || editorType == 'directions') && (
                        <DireccionEditor
                            id={stateEditor.editorID ?? id ?? "add"}
                            setEditor={setEditor}
                            setEditorID={setEditorID}
                        />
                    )}

                    {id &&
                        stateEditor.editorType == 'medios_svg_input' && <MediosInputSVGEditor />
                    }
                    {
                        id == null || id == null ?
                            stateEditor.editorType == 'medios_svg_input' && <MediosInputSVGEditor  />
                            :
                            ""
                    }


                    {id &&
                        stateEditor.editorType == 'medios_img_input' && <MediosInputImgEditor />
                    }
                    {
                        id == null || id == null ?
                            stateEditor.editorType == 'medios_img_input' && <MediosInputImgEditor />
                            :
                            ""
                    }




                    {/************************* CLIENTE EDITOR **********************************/}

                    {id &&
                        stateEditor.editorType == 'cliente_editor' && <ClienteEditor/>
                    }
                    {
                        id == null || id == null ?
                            stateEditor.editorType == 'cliente_editor' && <ClienteEditor />
                            :
                            ""
                    }


                    {id &&
                        stateEditor.editorType == 'cliente_view' && <ClienteViewer/>
                    }
                    {
                        id == null || id == null ?
                            stateEditor.editorType == 'cliente_view' && <ClienteViewer />
                            :
                            ""
                    }

                    {/************************* FIN CLIENTE EDITOR **********************************/}

                    {/************************* PROYECTO EDITOR **********************************/}
                    {id &&
                        stateEditor.editorType == 'proyecto_editor' && <ProyectoEditor/>
                    }
                    {
                        id == null || id == null ?
                            stateEditor.editorType == 'proyecto_editor' && <ProyectoEditor />
                            :
                            ""
                    }
                    {id &&
                        stateEditor.editorType == 'proyecto_viewer' && <ProyectoViewer/>
                    }
                    {
                        id == null || id == null ?
                            stateEditor.editorType == 'proyecto_viewer' && <ProyectoViewer />
                            :
                            ""
                    }
                    {/************************* FIN PROYECTO EDITOR **********************************/}

                    {/************************* PRESUPUESTO EDITOR **********************************/}
                    {stateEditor.editorType === 'presupuesto_editor' && (
                        <PresupuestoEditor  />
                    )}

                    {stateEditor.editorType === 'presupuesto_viewer' && stateEditor.editorID && (
                        <>
                            <PresupuestoViewer  />
                        </>
                    )}
                    {/************************* FIN PRESUPUESTO EDITOR **********************************/}



                    {/************************* ITEMPRESUPUESTO EDITOR **********************************/}
                    {stateEditor.editorType === 'item_presupuesto_editor' && (
                        <ItemPresupuestoEditor />
                    )}

                    {/*{editorType === 'item_presupuesto_editor' && id && (
                    <ItemPresupuestoViewer id={id} setEditor={setEditor} setEditorID={setEditorID} setEditorType={setEditorType} />
                )}*/}
                    {/************************* FIN ITEMPRESUPUESTO EDITOR **********************************/}


                    {/*********************************************************************************** */}
                    {/**                      VISUALIZADORES CLIENTE                                      */}
                    {/*********************************************************************************** */}


                    {/************************* VerMiProyecto **********************************/}

                    {stateEditor.editorType === 'mi_proyecto_viewer' && (
                        <VerMiProyecto />
                    )}
                    {/************************* FIN VerMiProyecto **********************************/}

                    {/************************* VerMiPresupuesto **********************************/}

                    {stateEditor.editorType === 'mi_presupuesto_viewer' && (
                        <VerMiPresupuesto/>
                    )}
                    {/************************* FIN VerMiPresupuesto **********************************/}



                    {/*********************************************************************************** */}
                    {/**                     FIN VISUALIZADORES CLIENTE                                      */}
                    {/*********************************************************************************** */}



                    {/*********************************************************************************** */}
                    {/**                      EDITORES DE PRODUCTO                                        */}
                    {/*********************************************************************************** */}


                    {/************************* ProductoEditor **********************************/}

                    {stateEditor.editorType === 'producto_editor' && (
                        <ProductoEditor editorID={stateEditor.editorID} />
                    )}
                    {/************************* FIN ProductoEditor **********************************/}



                    {/*********************************************************************************** */}
                    {/**                     FIN EDITORES DE PRODUCTO                                      */}
                    {/*********************************************************************************** */}




                    {/*********************************************************************************** */}
                    {/**                      EDITORES DE TOKENS ACTIVOS O ENLACES                        */}
                    {/*********************************************************************************** */}


                    {/************************* TokenLink  **********************************/}

                    {stateEditor.editorType === 'public_token_input' && (
                        // <ProductoEditor editorID={stateEditor.editorID} />
                        <TokenLinkEditor editorID={stateEditor.editorID} />
                    )}
                    {/************************* FIN TokenLink **********************************/}



                    {/*********************************************************************************** */}
                    {/**                      FIN EDITORES DE TOKENS ACTIVOS O ENLACES                    */}
                    {/*********************************************************************************** */}


                </div>

            </div>

            {/* El editor de perfil y el de direcciones llevan su propia flecha de
                volver integrada en la cabecera; solo el editor de medios sigue
                usando el botón flotante. */}
            {
                (['medios_svg_input'].includes(stateEditor.editorType)) && (

                        <DraggableBackButton
                            initialPosition={{ x: 0, y: "85px" }}
                            onClick={() => {
                                setEditor?.(false);
                                setStateEditor({
                                    ...stateEditor,
                                    editorType: null,
                                    editorID: null,
                                    editor: false
                                });
                            }}
                            iconPath={mdiArrowLeft}
                            label="Atrás"
                        />
                )
            }
        </div>

    )
}
export default Editor
